<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">PAYMENT GATEWAY CONFIGURATION</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item"><a @click="gotTo('settings')">Settings</a></li>
                      <li class="breadcrumb-item active">PAYMENT GATEWAYS</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alert Messages -->
            <div class="row" v-if="alert.success || alert.failed || alert.info">
              <div class="col-12">
                <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.success = false"></button>
                </div>
                <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.failed = false"></button>
                </div>
                <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Info!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.info = false"></button>
                </div>
              </div>
            </div>

            <!-- System Performance Metrics -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card border-primary">
                  <div class="card-header bg-primary text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-speedometer me-2"></i>
                      Real-time Payment System Performance
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="card bg-success text-white">
                          <div class="card-body text-center">
                            <div class="display-4 fw-bold">{{ performanceMetrics.currentTPS }}</div>
                            <div>TPS (Current)</div>
                            <small>Transactions Per Second</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="card bg-info text-white">
                          <div class="card-body text-center">
                            <div class="display-4 fw-bold">{{ performanceMetrics.peakTPS }}</div>
                            <div>Peak TPS (24h)</div>
                            <small>Maximum Achieved</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="card bg-warning text-dark">
                          <div class="card-body text-center">
                            <div class="display-4 fw-bold">{{ performanceMetrics.avgResponseTime }}ms</div>
                            <div>Avg Response</div>
                            <small>Transaction Processing</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="card bg-dark text-white">
                          <div class="card-body text-center">
                            <div class="display-4 fw-bold">{{ performanceMetrics.uptime }}%</div>
                            <div>System Uptime</div>
                            <small>Last 30 Days</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Real-time Transaction Graph -->
                    <div class="mt-4">
                      <h6>Live Transaction Throughput</h6>
                      <div class="bg-dark rounded p-3" style="height: 120px; position: relative;">
                        <canvas ref="throughputChart" style="width: 100%; height: 100%;"></canvas>
                        <div class="position-absolute top-0 end-0 p-2">
                          <span class="badge bg-success pulse">LIVE</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mobile Money Providers -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-success text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-cellphone me-2"></i>
                      Mobile Money Providers
                    </h4>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th>Provider</th>
                          <th>Status</th>
                          <th>API Version</th>
                          <th>Success Rate</th>
                          <th>Daily Volume</th>
                          <th>Avg Response</th>
                          <th>Last Health Check</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="provider in mobileMoneyProviders" :key="provider.id">
                          <td>
                            <div class="d-flex align-items-center">
                              <img :src="provider.logo" :alt="provider.name" style="width: 32px; height: 32px;" class="me-2">
                              <div>
                                <div class="fw-bold">{{ provider.name }}</div>
                                <small class="text-muted">{{ provider.code }}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span class="badge" :class="provider.status === 'ACTIVE' ? 'bg-success' : provider.status === 'MAINTENANCE' ? 'bg-warning' : 'bg-danger'">
                              {{ provider.status }}
                            </span>
                          </td>
                          <td>{{ provider.apiVersion }}</td>
                          <td>
                            <div class="d-flex align-items-center">
                              <span class="fw-bold me-2" :class="provider.successRate >= 99 ? 'text-success' : provider.successRate >= 95 ? 'text-warning' : 'text-danger'">
                                {{ provider.successRate }}%
                              </span>
                              <div class="progress flex-grow-1" style="height: 6px;">
                                <div class="progress-bar" :class="provider.successRate >= 99 ? 'bg-success' : provider.successRate >= 95 ? 'bg-warning' : 'bg-danger'"
                                     :style="{ width: provider.successRate + '%' }"></div>
                              </div>
                            </div>
                          </td>
                          <td>{{ formatCurrency(provider.dailyVolume) }}</td>
                          <td>{{ provider.avgResponse }}ms</td>
                          <td>{{ provider.lastHealthCheck }}</td>
                          <td>
                            <div class="d-flex gap-1">
                              <button @click="configureProvider(provider)" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#providerConfigModal">
                                <i class="mdi mdi-cog"></i>
                              </button>
                              <button @click="testProvider(provider)" class="btn btn-outline-success btn-sm">
                                <i class="mdi mdi-play"></i>
                              </button>
                              <button @click="toggleProvider(provider)" class="btn btn-outline-warning btn-sm">
                                <i class="mdi" :class="provider.status === 'ACTIVE' ? 'mdi-pause' : 'mdi-play'"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card Payment Processors -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-primary text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-credit-card me-2"></i>
                      Card Payment Processors
                    </h4>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th>Processor</th>
                          <th>Supported Cards</th>
                          <th>Status</th>
                          <th>Success Rate</th>
                          <th>Daily Volume</th>
                          <th>Transaction Fee</th>
                          <th>Settlement Time</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="processor in cardProcessors" :key="processor.id">
                          <td>
                            <div class="d-flex align-items-center">
                              <img :src="processor.logo" :alt="processor.name" style="width: 32px; height: 32px;" class="me-2">
                              <div>
                                <div class="fw-bold">{{ processor.name }}</div>
                                <small class="text-muted">{{ processor.gateway }}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex flex-wrap gap-1">
                              <span v-for="card in processor.supportedCards" :key="card" class="badge bg-light text-dark">
                                {{ card }}
                              </span>
                            </div>
                          </td>
                          <td>
                            <span class="badge" :class="processor.status === 'ACTIVE' ? 'bg-success' : 'bg-danger'">
                              {{ processor.status }}
                            </span>
                          </td>
                          <td>
                            <span class="fw-bold" :class="processor.successRate >= 99 ? 'text-success' : 'text-warning'">
                              {{ processor.successRate }}%
                            </span>
                          </td>
                          <td>{{ formatCurrency(processor.dailyVolume) }}</td>
                          <td>{{ processor.transactionFee }}%</td>
                          <td>{{ processor.settlementTime }}</td>
                          <td>
                            <div class="d-flex gap-1">
                              <button @click="configureProcessor(processor)" class="btn btn-outline-primary btn-sm">
                                <i class="mdi mdi-cog"></i>
                              </button>
                              <button @click="testProcessor(processor)" class="btn btn-outline-success btn-sm">
                                <i class="mdi mdi-play"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Banking Partners -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-info text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-bank me-2"></i>
                      Banking Partners & Direct Integrations
                    </h4>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th>Bank</th>
                          <th>Integration Type</th>
                          <th>Status</th>
                          <th>Services</th>
                          <th>Daily Volume</th>
                          <th>Success Rate</th>
                          <th>Last Sync</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="bank in bankingPartners" :key="bank.id">
                          <td>
                            <div class="d-flex align-items-center">
                              <img :src="bank.logo" :alt="bank.name" style="width: 32px; height: 32px;" class="me-2">
                              <div>
                                <div class="fw-bold">{{ bank.name }}</div>
                                <small class="text-muted">{{ bank.code }}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span class="badge" :class="bank.integrationType === 'DIRECT_API' ? 'bg-success' : bank.integrationType === 'WEBHOOK' ? 'bg-primary' : 'bg-warning'">
                              {{ bank.integrationType }}
                            </span>
                          </td>
                          <td>
                            <span class="badge" :class="bank.status === 'ACTIVE' ? 'bg-success' : 'bg-danger'">
                              {{ bank.status }}
                            </span>
                          </td>
                          <td>
                            <div class="d-flex flex-wrap gap-1">
                              <span v-for="service in bank.services" :key="service" class="badge bg-light text-dark">
                                {{ service }}
                              </span>
                            </div>
                          </td>
                          <td>{{ formatCurrency(bank.dailyVolume) }}</td>
                          <td>
                            <span class="fw-bold text-success">{{ bank.successRate }}%</span>
                          </td>
                          <td>{{ bank.lastSync }}</td>
                          <td>
                            <div class="d-flex gap-1">
                              <button @click="configureBank(bank)" class="btn btn-outline-primary btn-sm">
                                <i class="mdi mdi-cog"></i>
                              </button>
                              <button @click="syncBank(bank)" class="btn btn-outline-info btn-sm">
                                <i class="mdi mdi-sync"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Physical Agents Network -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-warning text-dark">
                    <h4 class="card-title mb-0">
                      <i class="mdi mdi-account-group me-2"></i>
                      Physical Agents Network
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <div class="card bg-primary text-white">
                          <div class="card-body text-center">
                            <h3 class="mb-0">{{ agentStats.totalAgents }}</h3>
                            <small>Total Agents</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="card bg-success text-white">
                          <div class="card-body text-center">
                            <h3 class="mb-0">{{ agentStats.activeAgents }}</h3>
                            <small>Active Today</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="card bg-info text-white">
                          <div class="card-body text-center">
                            <h3 class="mb-0">{{ formatCurrency(agentStats.dailyCollection) }}</h3>
                            <small>Daily Collection</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="card bg-warning text-dark">
                          <div class="card-body text-center">
                            <h3 class="mb-0">{{ agentStats.averageRating }}</h3>
                            <small>Avg Rating</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                      <table class="table table-hover">
                        <thead class="table-dark">
                        <tr>
                          <th>Agent</th>
                          <th>Location</th>
                          <th>Status</th>
                          <th>Today's Collection</th>
                          <th>Transactions</th>
                          <th>Rating</th>
                          <th>Last Active</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="agent in physicalAgents" :key="agent.id">
                          <td>
                            <div>
                              <div class="fw-bold">{{ agent.name }}</div>
                              <small class="text-muted">{{ agent.code }}</small>
                            </div>
                          </td>
                          <td>{{ agent.location }}</td>
                          <td>
                            <span class="badge" :class="agent.status === 'ONLINE' ? 'bg-success' : agent.status === 'OFFLINE' ? 'bg-danger' : 'bg-warning'">
                              {{ agent.status }}
                            </span>
                          </td>
                          <td>{{ formatCurrency(agent.todayCollection) }}</td>
                          <td>{{ agent.transactionCount }}</td>
                          <td>
                            <div class="d-flex align-items-center">
                              <span class="me-1">{{ agent.rating }}</span>
                              <div class="text-warning">
                                <i v-for="star in 5" :key="star" class="mdi"
                                   :class="star <= Math.floor(agent.rating) ? 'mdi-star' : 'mdi-star-outline'"></i>
                              </div>
                            </div>
                          </td>
                          <td>{{ agent.lastActive }}</td>
                          <td>
                            <div class="d-flex gap-1">
                              <button @click="viewAgent(agent)" class="btn btn-outline-primary btn-sm">
                                <i class="mdi mdi-eye"></i>
                              </button>
                              <button @click="contactAgent(agent)" class="btn btn-outline-success btn-sm">
                                <i class="mdi mdi-phone"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Transaction Load Testing -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card border-success">
                  <div class="card-header bg-success text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-flash me-2"></i>
                      High-Throughput Transaction Load Testing
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label class="form-label">Test Scenario</label>
                          <select v-model="loadTest.scenario" class="form-select">
                            <option value="PEAK_HOURS">Peak Hours Simulation</option>
                            <option value="BLACK_FRIDAY">Black Friday Load</option>
                            <option value="MONTH_END">Month-end Bill Rush</option>
                            <option value="CUSTOM">Custom Load Test</option>
                          </select>
                        </div>
                        <div class="mb-3">
                          <label class="form-label">Target TPS</label>
                          <select v-model="loadTest.targetTPS" class="form-select">
                            <option value="1000">1,000 TPS</option>
                            <option value="2500">2,500 TPS</option>
                            <option value="5000">5,000 TPS</option>
                            <option value="7500">7,500 TPS</option>
                            <option value="10000">10,000 TPS</option>
                          </select>
                        </div>
                        <div class="mb-3">
                          <label class="form-label">Duration (minutes)</label>
                          <input v-model="loadTest.duration" type="number" class="form-control" min="1" max="60">
                        </div>
                        <button @click="startLoadTest" :disabled="loadTest.running" class="btn btn-success">
                          <i v-if="!loadTest.running" class="mdi mdi-play me-1"></i>
                          <div v-else class="spinner-border spinner-border-sm me-1" role="status"></div>
                          {{ loadTest.running ? 'Running Test...' : 'Start Load Test' }}
                        </button>
                      </div>
                      <div class="col-md-6">
                        <div class="border rounded p-3 bg-light">
                          <h6>Current Test Results</h6>
                          <div v-if="loadTest.running || loadTest.results.tps">
                            <div class="row">
                              <div class="col-6">
                                <div class="text-center">
                                  <h4 class="text-success mb-0">{{ loadTest.results.tps }}</h4>
                                  <small>Current TPS</small>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="text-center">
                                  <h4 class="text-info mb-0">{{ loadTest.results.responseTime }}ms</h4>
                                  <small>Avg Response</small>
                                </div>
                              </div>
                            </div>
                            <div class="row mt-2">
                              <div class="col-6">
                                <div class="text-center">
                                  <h4 class="text-primary mb-0">{{ loadTest.results.successRate }}%</h4>
                                  <small>Success Rate</small>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="text-center">
                                  <h4 class="text-warning mb-0">{{ loadTest.results.totalProcessed }}</h4>
                                  <small>Total Processed</small>
                                </div>
                              </div>
                            </div>
                            <div v-if="loadTest.running" class="mt-3">
                              <div class="progress">
                                <div class="progress-bar progress-bar-striped progress-bar-animated"
                                     :style="{ width: loadTest.progress + '%' }"></div>
                              </div>
                              <small class="text-muted">{{ loadTest.progress }}% Complete</small>
                            </div>
                          </div>
                          <div v-else>
                            <p class="text-muted">No test running. Start a load test to see real-time metrics.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Provider Configuration Modal -->
        <ProviderConfigModal
            :provider="selectedProvider"
            @save-configuration="saveProviderConfig"
        />

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import ProviderConfigModal from "@/components/payments/modals/ProviderConfigModal.vue";
import router from "@/router";

export default {
  name: "PaymentConfiguration",
  components: {
    NavigationBar,
    ProviderConfigModal
  },
  data() {
    return {
      // Performance metrics
      performanceMetrics: {
        currentTPS: 3247,
        peakTPS: 4892,
        avgResponseTime: 245,
        uptime: 99.97
      },

      // Mobile Money Providers
      mobileMoneyProviders: [
        {
          id: 1,
          name: 'M-Pesa (Safaricom)',
          code: 'MPESA',
          logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0b/M-PESA.png',
          status: 'ACTIVE',
          apiVersion: 'v3.2',
          successRate: 99.8,
          dailyVolume: 125000000,
          avgResponse: 180,
          lastHealthCheck: '2025-01-16 14:30:00'
        },
        {
          id: 2,
          name: 'Airtel Money',
          code: 'AIRTEL',
          logo: 'https://nikulipe.com/wp-content/uploads/2022/09/Airtel_logo_PNG1.png',
          status: 'ACTIVE',
          apiVersion: 'v2.1',
          successRate: 98.9,
          dailyVolume: 45000000,
          avgResponse: 220,
          lastHealthCheck: '2025-01-16 14:29:00'
        },
        {
          id: 3,
          name: 'Equitel',
          code: 'EQUITEL',
          logo: 'https://equitygroupholdings.com/ke/media/f03psgfh/equitel.jpg',
          status: 'ACTIVE',
          apiVersion: 'v1.8',
          successRate: 99.2,
          dailyVolume: 28000000,
          avgResponse: 195,
          lastHealthCheck: '2025-01-16 14:28:00'
        },
        {
          id: 4,
          name: 'T-Kash (Telkom)',
          code: 'TKASH',
          logo: 'https://africabusinesscommunities.com/assets/components/phpthumbof/cache/telkom-kenya-t-kash.5d1980509d902384ff1c11754ca09153.jpg.pagespeed.ce.PgX1xOXA9W.jpg',
          status: 'MAINTENANCE',
          apiVersion: 'v2.0',
          successRate: 96.5,
          dailyVolume: 8500000,
          avgResponse: 350,
          lastHealthCheck: '2025-01-16 12:15:00'
        }
      ],

      // Card processors
      cardProcessors: [
        {
          id: 1,
          name: 'Visa Payment Gateway',
          gateway: 'VisaNet',
          logo: 'https://ikajo.com/wp-content/uploads/2020/03/visa.png',
          supportedCards: ['Visa', 'Visa Electron'],
          status: 'ACTIVE',
          successRate: 99.5,
          dailyVolume: 35000000,
          transactionFee: 2.8,
          settlementTime: 'T+1'
        },
        {
          id: 2,
          name: 'Mastercard Gateway',
          gateway: 'MasterNet',
          logo: 'https://cdn.prod.website-files.com/5dcecea1792b961987b80bb0/5f732800e2f350ed08f87037_MPGS.png',
          supportedCards: ['Mastercard', 'Maestro'],
          status: 'ACTIVE',
          successRate: 99.3,
          dailyVolume: 28000000,
          transactionFee: 2.9,
          settlementTime: 'T+1'
        },
        {
          id: 3,
          name: 'China UnionPay',
          gateway: 'UnionPay Gateway',
          logo: 'https://ibsintelligence.com/wp-content/uploads/2021/09/unionpay.jpg',
          supportedCards: ['UnionPay'],
          status: 'ACTIVE',
          successRate: 98.8,
          dailyVolume: 12000000,
          transactionFee: 3.2,
          settlementTime: 'T+2'
        }
      ],

      // Banking partners
      bankingPartners: [
        {
          id: 1,
          name: 'Kenya Commercial Bank',
          code: 'KCB',
          logo: 'https://upload.wikimedia.org/wikipedia/en/d/de/KCB_Bank_Kenya_Limited_logo.png',
          integrationType: 'DIRECT_API',
          status: 'ACTIVE',
          services: ['Fund Transfer', 'Bill Payment', 'Account Inquiry'],
          dailyVolume: 85000000,
          successRate: 99.7,
          lastSync: '2025-01-16 14:30:00'
        },
        {
          id: 2,
          name: 'Equity Bank',
          code: 'EQUITY',
          logo: 'https://upload.wikimedia.org/wikipedia/en/8/8a/Equity_Bank_Logo.png',
          integrationType: 'WEBHOOK',
          status: 'ACTIVE',
          services: ['Fund Transfer', 'Bill Payment'],
          dailyVolume: 72000000,
          successRate: 99.4,
          lastSync: '2025-01-16 14:25:00'
        },
        {
          id: 3,
          name: 'Co-operative Bank',
          code: 'COOP',
          logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d7/Coopbanklogo.jpg',
          integrationType: 'DIRECT_API',
          status: 'ACTIVE',
          services: ['Fund Transfer', 'Bill Payment', 'Balance Check'],
          dailyVolume: 55000000,
          successRate: 99.6,
          lastSync: '2025-01-16 14:20:00'
        },
        {
          id: 4,
          name: 'NCBA Bank',
          code: 'NCBA',
          logo: 'https://netbanking.cbabank.co.ug/eBanking/modelbank/unprotected/images/cbalogo.jpg',
          integrationType: 'DIRECT_API',
          status: 'ACTIVE',
          services: ['Fund Transfer', 'Bill Payment'],
          dailyVolume: 42000000,
          successRate: 99.1,
          lastSync: '2025-01-16 14:15:00'
        },
        {
          id: 5,
          name: 'Standard Chartered',
          code: 'STANCHART',
          logo: 'https://tech-ish.com/wp-content/uploads/2024/10/standardchartered@2x.png',
          integrationType: 'DIRECT_API',
          status: 'ACTIVE',
          services: ['Fund Transfer', 'International Transfer'],
          dailyVolume: 38000000,
          successRate: 99.8,
          lastSync: '2025-01-16 14:10:00'
        },
        {
          id: 6,
          name: 'Absa Bank',
          code: 'ABSA',
          logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/ABSA_Group_Limited_Logo.svg/1200px-ABSA_Group_Limited_Logo.svg.png',
          integrationType: 'WEBHOOK',
          status: 'ACTIVE',
          services: ['Fund Transfer', 'Bill Payment'],
          dailyVolume: 33000000,
          successRate: 99.3,
          lastSync: '2025-01-16 14:05:00'
        }
      ],

      // Physical agents
      agentStats: {
        totalAgents: 1247,
        activeAgents: 1089,
        dailyCollection: 45780000,
        averageRating: 4.6
      },

      physicalAgents: [
        {
          id: 1,
          name: 'John Mwangi - City Center',
          code: 'AGT001',
          location: 'Nairobi CBD, Kimathi Street',
          status: 'ONLINE',
          todayCollection: 485000,
          transactionCount: 127,
          rating: 4.8,
          lastActive: '2 mins ago'
        },
        {
          id: 2,
          name: 'Grace Wanjiku - Westlands',
          code: 'AGT024',
          location: 'Westlands, Sarit Center',
          status: 'ONLINE',
          todayCollection: 720000,
          transactionCount: 203,
          rating: 4.9,
          lastActive: '1 min ago'
        },
        {
          id: 3,
          name: 'Peter Kimani - Eastlands',
          code: 'AGT067',
          location: 'Eastleigh, 1st Avenue',
          status: 'BUSY',
          todayCollection: 320000,
          transactionCount: 89,
          rating: 4.5,
          lastActive: '5 mins ago'
        },
        {
          id: 4,
          name: 'Mary Achieng - South C',
          code: 'AGT145',
          location: 'South C Shopping Center',
          status: 'OFFLINE',
          todayCollection: 180000,
          transactionCount: 45,
          rating: 4.3,
          lastActive: '2 hours ago'
        },
        {
          id: 5,
          name: 'David Mburu - Karen',
          code: 'AGT089',
          location: 'Karen Shopping Center',
          status: 'ONLINE',
          todayCollection: 560000,
          transactionCount: 134,
          rating: 4.7,
          lastActive: '30 secs ago'
        }
      ],

      // Load testing
      loadTest: {
        scenario: 'PEAK_HOURS',
        targetTPS: 5000,
        duration: 10,
        running: false,
        progress: 0,
        results: {
          tps: 0,
          responseTime: 0,
          successRate: 0,
          totalProcessed: 0
        }
      },

      selectedProvider: {},

      // Chart reference
      throughputChart: null,
      chartInterval: null,

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  mounted() {
    this.initializeThroughputChart();
    this.startRealTimeMetrics();
    this.menuAccess();
  },
  beforeUnmount() {
    if (this.chartInterval) {
      clearInterval(this.chartInterval);
    }
  },
  methods: {
    getRight,

    gotTo(route) {
      router.push(route);
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    },

    initializeThroughputChart() {
      const canvas = this.$refs.throughputChart;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const width = canvas.offsetWidth;
      const height = canvas.offsetHeight;
      canvas.width = width;
      canvas.height = height;

      this.chartData = {
        timestamps: [],
        values: []
      };

      // Initialize with some data
      for (let i = 0; i < 50; i++) {
        this.chartData.timestamps.push(Date.now() - (50 - i) * 1000);
        this.chartData.values.push(Math.random() * 2000 + 2000);
      }

      this.drawChart();
    },

    drawChart() {
      const canvas = this.$refs.throughputChart;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const width = canvas.width;
      const height = canvas.height;

      // Clear canvas
      ctx.clearRect(0, 0, width, height);

      // Set up chart styling
      ctx.strokeStyle = '#00ff88';
      ctx.lineWidth = 2;
      ctx.fillStyle = 'rgba(0, 255, 136, 0.1)';

      if (this.chartData.values.length === 0) return;

      const maxValue = Math.max(...this.chartData.values);
      const minValue = Math.min(...this.chartData.values);
      const range = maxValue - minValue || 1;

      // Draw line chart
      ctx.beginPath();

      this.chartData.values.forEach((value, index) => {
        const x = (index / (this.chartData.values.length - 1)) * width;
        const y = height - ((value - minValue) / range) * height;

        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });

      ctx.stroke();

      // Fill area under curve
      ctx.lineTo(width, height);
      ctx.lineTo(0, height);
      ctx.closePath();
      ctx.fill();
    },

    startRealTimeMetrics() {
      this.chartInterval = setInterval(() => {
        // Update performance metrics
        this.performanceMetrics.currentTPS = Math.floor(Math.random() * 1000) + 2500;

        // Update chart data
        this.chartData.timestamps.push(Date.now());
        this.chartData.values.push(this.performanceMetrics.currentTPS);

        // Keep only last 50 data points
        if (this.chartData.timestamps.length > 50) {
          this.chartData.timestamps.shift();
          this.chartData.values.shift();
        }

        this.drawChart();
      }, 1000);
    },

    configureProvider(provider) {
      this.selectedProvider = provider;
    },

    testProvider(provider) {
      this.message = `Testing connection to ${provider.name}...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = `${provider.name} test completed successfully!`;
        this.alert.success = true;
      }, 2000);
    },

    toggleProvider(provider) {
      const newStatus = provider.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
      provider.status = newStatus;

      this.message = `${provider.name} has been ${newStatus.toLowerCase()}`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 3000);
    },

    configureProcessor(processor) {
      this.message = `Configuring ${processor.name}...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 2000);
    },

    testProcessor(processor) {
      this.message = `Testing ${processor.name} gateway...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = `${processor.name} test completed successfully!`;
        this.alert.success = true;
      }, 2000);
    },

    configureBank(bank) {
      this.message = `Configuring ${bank.name} integration...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 2000);
    },

    syncBank(bank) {
      this.message = `Syncing with ${bank.name}...`;
      this.alert.info = true;

      setTimeout(() => {
        bank.lastSync = new Date().toLocaleString();
        this.alert.info = false;
        this.message = `${bank.name} sync completed successfully!`;
        this.alert.success = true;
      }, 3000);
    },

    viewAgent(agent) {
      this.message = `Viewing details for ${agent.name}`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 2000);
    },

    contactAgent(agent) {
      this.message = `Contacting ${agent.name}...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 2000);
    },

    startLoadTest() {
      this.loadTest.running = true;
      this.loadTest.progress = 0;
      this.loadTest.results = {
        tps: 0,
        responseTime: 0,
        successRate: 0,
        totalProcessed: 0
      };

      const targetTPS = parseInt(this.loadTest.targetTPS);
      const duration = this.loadTest.duration * 60; // Convert to seconds

      const testInterval = setInterval(() => {
        this.loadTest.progress += 1;

        // Simulate realistic load test metrics
        this.loadTest.results.tps = Math.floor(Math.random() * 500) + (targetTPS - 250);
        this.loadTest.results.responseTime = Math.floor(Math.random() * 100) + 200;
        this.loadTest.results.successRate = 99.5 + (Math.random() * 0.5);
        this.loadTest.results.totalProcessed += this.loadTest.results.tps;

        if (this.loadTest.progress >= 100) {
          clearInterval(testInterval);
          this.loadTest.running = false;
          this.message = `Load test completed! Peak TPS: ${Math.max(targetTPS - 100, this.loadTest.results.tps)}`;
          this.alert.success = true;
        }
      }, (duration * 10)); // Update every 1% of duration
    },

    saveProviderConfig(config) {
      this.message = `Configuration saved for ${config.name}`;
      this.alert.success = true;

      setTimeout(() => {
        this.alert.success = false;
        this.message = '';
      }, 3000);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Payment Configuration");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}

.display-4 {
  font-size: 2.5rem;
}

.progress {
  height: 8px;
}

canvas {
  border-radius: 4px;
}
</style>